import React, { Component } from 'react';
import PropTypes from 'prop-types';

function isInProduction() {
  return process.env.NODE_ENV === 'production';
}

function isInIFrame() {
  return window.top !== window;
}

function isEmbeddedWebView() {
  return Boolean(window.Android || window.webkit);
}

function isMobileEmulationMode() {
  return ('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0) || (typeof document.body.ongesturestart === 'function');
}

export default class Wrapper extends Component {
  static shouldRenderShell() {
    return !isInProduction() && !isInIFrame() && !isEmbeddedWebView() && !isMobileEmulationMode();
  }

  render() {
    if (this.props.children) throw new Error('The <DevWrapper /> component should never have children passed to it.');

    return <DevWrapper { ...this.props } />;
  }
}

Wrapper.propTypes = {
  children: PropTypes.any
};

class DevWrapper extends Component {
  constructor(props) {
    super(props);

    this.state = { crossBoundaryCalls: [] };

    this.simulateNativeToJSCall = this.simulateNativeToJSCall.bind(this);
  }

  componentDidMount() {
    const frameWindow = this.getIframeWindow();
    frameWindow.Android = {
      isFake: true,
      callNative: (data) => {
        this.setState({ crossBoundaryCalls: [...this.state.crossBoundaryCalls, `(JS -> N) ${new Date()}:\n${data}`] });
      }
    };
  }

  getIframeWindow() {
    return document.querySelector('iframe').contentWindow;
  }

  simulateNativeToJSCall() {
    const payload = window.prompt('Enter the payload you wish to simulate coming from mobile:');
    if (!payload) return;

    let parsedPayload = eval(`(${payload})`); //eslint-disable-line no-eval

    if (typeof parsedPayload === 'string') {
      parsedPayload = { methodName: parsedPayload };
    }

    const jsonPayload = JSON.stringify(parsedPayload);
    this.setState({ crossBoundaryCalls: [...this.state.crossBoundaryCalls, `(N -> JS) ${new Date()}:\n${jsonPayload}`] });
    this.getIframeWindow().callJavaScript(jsonPayload);
  }

  render() {
    const buttonStyles = {
      position: 'fixed',
      top: '15px',
      height: '25px',
      width: '200px',
      left: '50%',
      marginLeft: '-100px'
    };

    const dynamicFrameStyles = {
      border: '5px solid black',
      width: `${this.props.width}px`,
      height: `${this.props.height}px`,
      position: 'fixed',
      top: '65px',
      left: '50%',
      marginLeft: `-${this.props.width / 2}px`
    };

    const dynamicTextAreaStyles = {
      width: `${this.props.width}px`,
      height: '150px',
      position: 'fixed',
      top: `${100 + this.props.height}px`,
      left: '50%',
      marginLeft: `-${this.props.width / 2}px`
    };

    return (
      <section>
        <button style={ buttonStyles } onClick={ this.simulateNativeToJSCall }>Simulate Native -> JS Call</button>
        <iframe style={ dynamicFrameStyles } src={ window.location.href } title="iFit" />
        <textarea style={ dynamicTextAreaStyles } readOnly value={ 'Cross-Boundary Call Log:\n\n' + this.state.crossBoundaryCalls.join('\n\n') } />
      </section>
    );
  }
}

DevWrapper.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number
};

DevWrapper.defaultProps = {
  height: 667,
  width: 1024
};
